<alert id="case-index-search-results-table-alert" type="danger" *ngFor="let error of errors">{{error}}</alert>
<div class="table-responsive" id="case-index-search-result-table-wrapper-div" *ngIf="cases">
  <table id="case-index-search-results-table"
         class="table full-width table-hover table-condensed table-nowrap">
    <thead id="case-index-search-results-table-header">
      <tr>
          <ng-template #popTemplateForCounty><div [innerHtml]="tableColumnHeaders[2].popoverTemplate"></div></ng-template>
           <ng-template #popTemplateForAction><div [innerHtml]="tableColumnHeaders[5].popoverTemplate"></div></ng-template>
        <th *ngFor="let header of tableColumnHeaders;" width="{{header.headerWidth}}">
            <span *ngIf="header.vcode" class="field-code">{{header.vcode}} </span>{{header.headerName}}
            <span *ngIf="header.headerNamePart2"><br><span *ngIf="header.vcode2" class="field-code">{{header.vcode2}} </span>{{header.headerNamePart2}}</span> 
            <span *ngIf="(header.popoverShow && header.headerName !=='County' && header.headerName !=='Case Status' && header.headerName !=='Actions')" 
                  popover="{{header.popoverContent}}" popoverTitle="{{header.popoverTitle}}"><i class="fa fa-info-circle"></i></span>           
            <span *ngIf="(header.popoverShow && header.headerName ==='County')" 
                  [popover]="popTemplateForCounty" popoverTitle="{{header.popoverTitle}}"><i class="fa fa-info-circle"></i></span>
            <span *ngIf="(header.popoverShow && header.headerName ==='Actions')" 
                  [popover]="popTemplateForAction" popoverTitle="{{header.popoverTitle}}"><i class="fa fa-info-circle"></i></span>
        </th>
      </tr>
    </thead>
    <tbody id="case-index-search-results-table-tbody">
      <tr *ngFor="let case of cases; let i = index;" 
          (click)="onViewCaseSelected(case.getCaseIdentifier())"
          [class.highlighted-bgcolor]="rowFocusedFlags[i]">
        <td id="{{'case-index-search-results-row-' + i + '-detor'}}" 
            width="{{tableColumnWidths[0]}}"
            title="Click for Case View">
            <div class="table-responsive scroll-hide-xy"> 
              <table class="full-width table-nowrap">
                <tr *ngIf="case.getPartyName()">
                  <td class="text-align-left" >
                    <span *ngIf="case.isPartyNameAsAlias()"><span class="field-code">V489.a </span>(Alias) </span>
                    <span title="{{case.getPartyName()}}"><span class="field-code">V489 </span>{{case.getPartyName()}}</span>
                  </td>
                </tr>
                <tr *ngIf="case.isPartyNameChanged() && case.getPartyChangedToName()">
                  <td class="text-align-left">
                   <span class="field-code">V489 </span><span title="Changed To: {{case.getPartyChangedToName()}}">Changed To: {{case.getPartyChangedToName()}}</span>
                  </td>
                </tr>
                <!--<tr *ngIf="case.getPartyNameChangedFromOrTo()"><td class="text-align-left name-subline-color" title="{{case.getPartyNameChangedFromOrTo()}}">{{case.getPartyNameChangedFromOrTo()}}</td></tr>-->
                <tr *ngIf="(case.getPartyAliasCount() === 1)"><td class="text-align-left name-subline-color" title="+{{case.getPartyAliasCount()}} alias"><span class="field-code">V492 </span>+{{case.getPartyAliasCount()}} alias</td></tr>
                <tr *ngIf="(case.getPartyAliasCount() > 1)"><td class="text-align-left name-subline-color" title="+{{case.getPartyAliasCount()}} aliases"><span class="field-code">V492 </span>+{{case.getPartyAliasCount()}} aliases</td></tr>
                <tr *ngIf="(case.getPartyRole()||case.getPartyTitle())">
                  <td class="text-align-left name-subline-color">
                    (<span *ngIf="case.getPartyRole()" title="{{case.getPartyRole()}}"><span class="field-code">V052.y </span>{{case.getPartyRole()}}</span>
                     <span *ngIf="(case.getPartyRole() &&  case.getPartyTitle())"> - </span>
                     <span *ngIf="case.getPartyTitle()" title="{{case.getPartyTitle()}}"><span class="field-code">V107.c </span>{{case.getPartyTitle()}}</span>)
                  </td>
                </tr>
              </table>
            </div>
        </td>
        <td id="{{'case-index-search-results-row-' + i + '-opposing-party'}}" 
            width="{{tableColumnWidths[1]}}"
            title="Click for Case View">
            <div class="table-responsive scroll-hide-xy"> 
              <table class="full-width table-nowrap">
                <tr *ngIf="!case.isOtherDataPresent()"><td><i class="fa fa-spinner fa-pulse text-center"></i></td></tr>
                <tr *ngIf="case.getOpposingPartyName()"><td class="text-align-left" title="{{case.getOpposingPartyName()}}"><span class="field-code">V493 </span>{{case.getOpposingPartyName()}}</td></tr>
                <tr *ngIf="(case.getOpposingPartyAliasCount() || case.getOpposingOtherPartyCount())">
                  <td class="text-align-left name-subline-color">
                    <span *ngIf="(case.getOpposingPartyAliasCount() === 1)" title="+{{case.getOpposingPartyAliasCount()}} alias"><span class="field-code">V494 </span>+{{case.getOpposingPartyAliasCount()}} alias</span> 
                    <span *ngIf="(case.getOpposingPartyAliasCount() > 1)" title="+{{case.getOpposingPartyAliasCount()}} aliases"><span class="field-code">V494 </span>+{{case.getOpposingPartyAliasCount()}} aliases</span> 
                    <span *ngIf="((case.getOpposingPartyAliasCount() >= 1) && (case.getOpposingOtherPartyCount() >= 1))">,&nbsp;</span>
                    <span *ngIf="(case.getOpposingOtherPartyCount() === 1)" title="+{{case.getOpposingOtherPartyCount()}} party"><span class="field-code">V496 </span>+{{case.getOpposingOtherPartyCount()}} party</span> 
                    <span *ngIf="(case.getOpposingOtherPartyCount() > 1)" title="+{{case.getOpposingOtherPartyCount()}} parties"><span class="field-code">V496 </span>+{{case.getOpposingOtherPartyCount()}} parties</span> 
                  </td>
                </tr>
                <tr *ngIf="(case.getOpposingPartyRole() || case.getOpposingPartyTitle())">
                  <td class="text-align-left name-subline-color">
                    (<span *ngIf="case.getOpposingPartyRole()" title="{{case.getOpposingPartyRole()}}"><span class="field-code">V052.z </span>{{case.getOpposingPartyRole()}}</span>
                     <span *ngIf="(case.getOpposingPartyRole() &&  case.getOpposingPartyTitle())"> - </span>
                     <span *ngIf="case.getOpposingPartyTitle()" title="{{case.getOpposingPartyTitle()}}"><span class="field-code">V107.d </span>{{case.getOpposingPartyTitle()}}</span>) 
                  </td>
                </tr>
              </table>
            </div>
        </td>
        <td id="{{'case-index-search-results-row-' + i + '-county-case-number'}}" 
            width="{{tableColumnWidths[2]}}"
            title="Click for Case View"><span  title="{{case.getCaseCounty() + ' ' + case.getCaseNumber()}}">{{case.getCaseCounty()}}<br>{{case.getCaseNumber()}}</span><span *ngIf="case.getTranscriptedToCounty()" title="Transcripted to {{ case.getTranscriptedToCounty()}}"><br>Transcripted to {{ case.getTranscriptedToCounty()}}</span></td>
        <td id="{{'case-index-search-results-row-' + i + '-issue'}}" 
            width="{{tableColumnWidths[3]}}"
            title="Click for Case View"><span title="{{case.getIssueDescription()}}">{{case.getIssueDescription()}}</span></td>
        <td id="{{'case-index-search-results-row-' + i + '-judgment-location'}}" 
            width="{{tableColumnWidths[4]}}"            
            title="Click for Case View"><span *ngIf="case.isOtherDataPresent()" title="{{case.getJudgmentLocation()}}">{{case.getJudgmentLocation()}}</span><br><span *ngIf="case.isOtherDataPresent() && case.getJudgmentStatus()" title="{{case.getJudgmentStatus()}}">({{case.getJudgmentStatus()}})</span><span *ngIf="!case.isOtherDataPresent()"><i class="fa fa-spinner fa-pulse text-center"></i></span></td>
        <!--
        <td id="{{'case-index-search-results-row-' + i + '-judgment-status'}}" 
            width="{{tableColumnWidths[5]}}"
            title="Click for Case View"><span title="{{case.getJudgmentStatus()}}">{{case.getJudgmentStatus()}}</span> </td>
        -->
        <td id="{{'case-index-search-results-row-' + i + '-actions'}}" 
            width="{{tableColumnWidths[5]}}" 
            (click)="$event.stopPropagation()">
          <a id="{{'case-index-search-results-row-'+ i + '-action-view-case-lnk'}}"
             tabindex="{{3000 + i*3 + 1}}"
             title="Click for Case View" 
             (click)="onViewCaseSelected(case.getCaseIdentifier())"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)">
             <span class="glyphicon glyphicon-folder-open"></span><span> View Case</span></a><br>
          <a id="{{'case-index-search-results-row-'+ i + '-action-add-case-to-cart-lnk'}}" 
             tabindex="{{3000 + i*3 + 2}}"
             title="Click for Adding Case to Cart" 
             (click)="addCaseToCart(case)"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)"
              *ngIf="!isCaseInCart(case.getCaseIdentifier())">
              <span class="glyphicon glyphicon-shopping-cart"></span><span> Add to Cart</span>
          </a>
          <a id="{{'case-index-search-results-row-'+ i + '-action-remove-case-from-cart-lnk'}}"
             tabindex="{{3000 + i*3 + 3}}"
             title="Click for Removing Case from Cart" 
             (click)="removeCaseFromCart(case)"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)"
             *ngIf="isCaseInCart(case.getCaseIdentifier())"  >
             <span class="glyphicon glyphicon-shopping-cart"></span><span > Remove</span>
          </a>
        </td>
      </tr>
     </tbody>
  </table>
</div>
<div *ngIf="requestIsInFlight" class="text-center">
  <i id="civil-search-spinner" class="fa fa-spinner fa-pulse fa-5x text-center"></i>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-index-search-results-table/civil-index-search-results-table.component.html